<template>
  <div class="c-contentsFreeText">
    <div
      class="c-contentsFreeText_text"
      v-html="content"
      :style="{ height: elStyleHeight }"
      ref="freeTextArea"
    ></div>
    <div
      class="c-contentsFreeText_readMore"
      v-if="freeTextNeedReadMore && !freeTextExpanded"
    >
      <a @click="expandFreeText">
        すべて読む
        <coconala-icon
          name="chevron-down"
          size="11px"
        />
      </a>
    </div>
  </div>
</template>
<script>
import { mapGetters, mapState } from 'vuex'

export default {
  name: 'ContentsFreeText',
  props: {
    freeText: {
      type: String,
      defalut: ''
    },
    expansion: {
      type: Boolean,
      default: false
    },
    limitHeight: {
      type: Number,
      default: 375
    },
    limitCount: {
      type: Number,
      default: 400
    },
    limitRows: {
      type: Number,
      default: 15
    }
  },
  data() {
    return {
      freeTextExpanded: true,
      elHeight: 0,
      elStyleHeight: 'auto',
      content: this.freeText
    }
  },
  fetch() {
    this.autoLink()
  },
  computed: {
    ...mapGetters('auth', ['isLoggedIn']),
    ...mapState('constants', ['COCONALA_WHITE_LIST_URL']),
    freeTextNeedReadMore() {
      if (!this.freeText) {
        return false
      }

      if (this.expansion && this.elHeight > this.limitHeight) {
        return true
      }

      return false
    }
  },
  mounted() {
    if (this.isLoggedIn) {
      this.freeTextExpanded = false
      this.elHeight = this.$refs.freeTextArea.clientHeight
      if (this.expansion && this.elHeight > this.limitHeight) {
        this.elStyleHeight = `${this.limitHeight}px`
      }
    }
  },
  methods: {
    expandFreeText() {
      this.freeTextExpanded = true
      this.elStyleHeight = 'auto'
    },
    autoLink() {
      const WHITE_LIST_URL_PATTERN = Object.values(this.COCONALA_WHITE_LIST_URL).join('|')
      const reg = new RegExp(`(${WHITE_LIST_URL_PATTERN})`, 'g')

      const content = this.$util.htmlspecialchars(this.freeText)
      this.content = content.replace(reg, match => {
        return `<a target="_blank" rel="noopener" href="${match}">${match}</a>`
      })
    }
  }
}
</script>
<style lang="scss" scoped>
.c-contentsFreeText {
  &_text {
    white-space: pre-wrap;
    word-wrap: break-word;
    overflow: hidden;
  }

  &_readMore {
    margin-top: 4px;
    margin-bottom: 8px;
    color: $color-blue-500;
    font-size: 13px;
    position: relative;

    &::after {
      content: '';
      display: block;
      position: absolute;
      top: -24px;
      width: 100%;
      height: 20px;
      background-image: linear-gradient(
        to bottom,
        rgba(255, 255, 255, 0) 0%,
        rgba(255, 255, 255, 1) 100%
      );
    }
  }
}

@media (max-width: breakpoint(ServiceDetail, M)) {
  .c-contentsFreeText {
    &_readMore {
      padding: 12px 0;
      text-align: center;
      font-size: 12px;
    }
  }
}
</style>
